module.exports = __webpack_public_path__ + "static/img/celoscope-13.3816ebe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-13.jpg
// module id = LFjS
// module chunks = 52